import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormInput,
  title: 'Input',
  category: ComponentCategory.FormControls,
};
